import React from 'react';
import { Box } from 'native-base';
import { useGiftCardStyles } from './styles';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';
import Image, { LogoMd } from '~/shared/Image';
import { H3, H4 } from './Typography';

type Props = {
    amount: string;
    size: string;
};

const MockGiftCard = ({ amount, size }: Props) => {

    const {
        card_color,
        card_text_color,
    } = useGiftCardStyles();

    const { merchant } = useSpringBigStore();
    const { customIcons } = useAppSettings();
    const fontSize = size === 'lg' ? 30 : 14;
    const fontWeight = size === 'lg' ? 'bold' : 'normal';

    return (
        <Box
            backgroundColor={card_color}
            borderRadius={8}
            p={2}
            style={{ aspectRatio: 1.628 / 1 }}
        >
            <H4
                position='absolute'
                top='7%'
                left='5%'
                color={card_text_color}
                fontSize={fontSize}
                fontWeight={fontWeight}
            >
                { merchant?.gift_card_alias }
            </H4>

            {customIcons && customIcons.GiftCardIcon &&
                <Image position='absolute' top='7%' right='2%' uri={customIcons.GiftCardIcon} h={35} w={35} />
            }

            <H3
                position='absolute'
                bottom='7%'
                right='5%'
                color={card_text_color}
                fontSize={fontSize}
                fontWeight={fontWeight}
            >
                { amount }
            </H3>
        </Box>
    );
};

export default MockGiftCard;
